<svg width="18" height="12">
    <line x1="5" y1="11" x2="11" y2="1" stroke-width="3" stroke="#055759"/>
    <line x1="6" y1="11" x2="1" y2="6" stroke-width="3" stroke="#055759"/>
</svg>